
import XHeader from 'vux/src/components/x-header/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'

import {giftList, myEmbryoList,examineList,GoodpregnancyList,TimeLimitList} from './js/gift';
export default {
data(){
return{
headerTxt:'',
list:[],
employ:0,
}
},
components: {
XHeader,Grid, GridItem, GroupTitle
},
methods:{
ListClick(item){

if(this.headerTxt == '冻胚续费'){
this.$router.push({path:'/integraMallEmbryo',query:{openid:this.$route.query.openid,txt:item.txt,personInfoId:this.$route.query.personInfoId,sfzh:this.$route.query.sfzh,Mypoints:this.$route.query.toalMypoints,xm:this.$route.query.xm,sign:this.$route.query.sign,hosCode:this.$route.query.hosCode}});
}else if(this.headerTxt == '诊疗服务'){
this.$router.push({path:'/integralMallExamine?urlimg='+item.txt+'&title=诊疗服务&sign='+this.$route.query.sign+'&hosCode='+this.$route.query.hosCode});
}else if(this.headerTxt == '充值礼品卡'){
this.$router.push({path:'/integralMallDetail',query:{openid:this.$route.query.openid,personInfoId:this.$route.query.personInfoId,Mypoints:this.$route.query.Mypoints,goodsid:item.goodsid,title:item.title,xm:this.$route.query.xm,sfzh:this.$route.query.sfzh,sign:this.$route.query.sign,hosCode:this.$route.query.hosCode}});
}else if(this.headerTxt == '好孕礼包'){
this.$router.push({path:'/integralMallExamine?good=好孕礼包&title=好孕礼包&goodid='+item.goodid + '&Mypoints=' + this.$route.query.Mypoints + '&personInfoId=' +this.$route.query.personInfoId + '&openid=' +this.$route.query.openid,sign:this.$route.query.sign,hosCode:this.$route.query.hosCode});
}else if(this.headerTxt == '限时礼包'){
this.$router.push({path:'/integralMallExamine?good=限时礼包&title=限时礼包&goodid='+item.goodid + '&Mypoints=' + this.$route.query.Mypoints + '&personInfoId=' +this.$route.query.personInfoId + '&openid=' +this.$route.query.openid,sign:this.$route.query.sign,hosCode:this.$route.query.hosCode});
}
}
},
mounted(){

if(window.localStorage.getItem('card')){
this.employ = window.localStorage.getItem('card');
}
this.headerTxt = this.$route.query.headeTxt;
if(this.headerTxt == '冻胚续费'){
this.list = myEmbryoList;
}else if(this.headerTxt == '诊疗服务'){
this.list = examineList;
}else if(this.headerTxt == '充值礼品卡'){
if(this.$route.query.detail == '京东'){
this.list = giftList.slice(0,2);
}else if(this.$route.query.detail == '伊藤'){
this.list = giftList.slice(2,4);
}else if(this.$route.query.detail == '红旗'){

this.list = giftList.slice(4,5);
/*    console.log(giftList,453434234,this.list)*/
}
}else if(this.headerTxt == '好孕礼包'){
this.list = GoodpregnancyList;
}else if(this.headerTxt == '限时礼包'){

for(let i =0;i<TimeLimitList.length;i++){

if(this.employ != 2 && this.employ != 1){  // 患者

if(TimeLimitList[i].txt.indexOf('JCI') !=-1){

}else{
this.list.push(TimeLimitList[i]);
}

}else{      // 员工
if(TimeLimitList[i].txt.indexOf('JCI') !=-1){
this.list.push(TimeLimitList[i]);
}
}

}

}
}
}



// WEBPACK FOOTER //
// ./src/project/integralMallProject/integralMallList.vue